module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "griddy-contain"
  }, [_vm._m(0), _vm._v(" "), _c('videoBg')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "griddy container is-flui"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }), _vm._v(" "), _c('div', {
    staticClass: "column is-hidden-mobile"
  }, [_c('h1', [_vm._v("SARIKAYA\n          "), _c('span', {
    staticClass: "plus"
  }, [_vm._v("+")]), _vm._v(" "), _c('span', {
    staticClass: "s"
  }, [_vm._v("S")]), _vm._v("AH"), _c('span', {
    staticClass: "i"
  }, [_vm._v("I")]), _vm._v("N")])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("Günümüzde yaşanan teknolojik ve ekonomik değişimlerin etkileri, hukuk alanında da kendini göstermektedir. Bu etkiler, dinamik, açık görüşlü, yenilikleri ve teknolojik gelişmeleri yakından takip eden hukukçulara olan ihtiyacı da beraberinde getirmektedir. Sarıkaya + Şahin, bu ihtiyaca cevap verebilmeyi ve hizmet verdiği alanlarda daha iyiye ulaşmayı temel hedefi olarak belirlemektedir.")]), _vm._v(" "), _c('span', {
    staticClass: "liner"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eb3d340","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/homepage-tr.vue
// module id = 159
// module chunks = 0